import * as types from "../types/index";
import { setInitialState } from "../InitialState";


const INITIAL_STATE = setInitialState({
    data: null,
});


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.PATHWAY_COMPLETE_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.PATHWAY_COMPLETE_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                data: action.payload.success
            };
        case types.PATHWAY_COMPLETE_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                data: action.payload.response.error,
            };
        case types.RESET_PATHWAY_COMPLETE:
            return {
                ...state,
                isFetching: false,
                isError: false,
                data: null,
            };
        default:
            return {
                ...state
            }
    }
}